module.exports = __webpack_public_path__ + "static/media/animal-giraffe.8bf86e92.png";